import React, { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

const Exit_image_upload = () => {
  const [religion, setReligion] = useState("");
  const [images, setImages] = useState({
    ldpi: null,
    mdpi: null,
    hdpi: null,
    xhdpi: null,
    xxhdpi: null,
    xxxhdpi: null,
  });
  const [rowData, setRowData] = useState([]);
  const [errors, setErrors] = useState({});
  const [editingRow, setEditingRow] = useState(null);

  useEffect(() => {
    // Fetch existing image data from the server
    axios
      .get("http://localhost:3001/images")
      .then((response) => setRowData(response.data))
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const ImageRenderer = (params) => {
    return params.value ? <img src={params.value} alt="Image" className="h-12" /> : null;
  };

  const columnDefs = [
    { headerName: "SNo", valueGetter: (params) => params.node.rowIndex + 1 },
    { headerName: "Religion", field: "religion", flex: 1 },
    { headerName: "ldpi images", field: "ldpiUrl", cellRenderer: ImageRenderer },
    { headerName: "mdpi images", field: "mdpiUrl", cellRenderer: ImageRenderer },
    { headerName: "hdpi images", field: "hdpiUrl", cellRenderer: ImageRenderer },
    { headerName: "xhdpi images", field: "xhdpiUrl", cellRenderer: ImageRenderer },
    { headerName: "xxhdpi images", field: "xxhdpiUrl", cellRenderer: ImageRenderer },
    { headerName: "xxxhdpi images", field: "xxxhdpiUrl", cellRenderer: ImageRenderer },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <div className="flex space-x-2">
          <button
            className="text-blue-500 hover:underline"
            onClick={() => handleEdit(params.data)}
          >
            Edit
          </button>
          <button
            className="text-red-500 hover:underline"
            onClick={() => handleDelete(params.data.id)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  const handleInputChange = (e) => {
    const { name, files } = e.target;
    setImages({ ...images, [name]: files[0] });
    setErrors({ ...errors, [name]: "" });
  };

  const handleSave = () => {
    const newErrors = {};
    if (!religion) newErrors.religion = "Religion is required.";
    if (!images.ldpi) newErrors.ldpi = "ldpi image is required.";
    if (!images.mdpi) newErrors.mdpi = "mdpi image is required.";
    if (!images.hdpi) newErrors.hdpi = "hdpi image is required.";
    if (!images.xhdpi) newErrors.xhdpi = "xhdpi image is required.";
    if (!images.xxhdpi) newErrors.xxhdpi = "xxhdpi image is required.";
    if (!images.xxxhdpi) newErrors.xxxhdpi = "xxxhdpi image is required.";
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    const formData = new FormData();
    formData.append("religion", religion);
    Object.keys(images).forEach((key) => {
      formData.append(key, images[key]);
    });

    if (editingRow) {
      axios
        .put(`http://localhost:3001/images/${editingRow.id}`, formData)
        .then(() => {
          setRowData((prevData) =>
            prevData.map((row) =>
              row.id === editingRow.id ? { ...row, religion, ...images } : row
            )
          );
          resetForm();
        })
        .catch((error) => console.error("Error updating image:", error));
    } else {
      axios
        .post("http://localhost:3001/images", formData)
        .then((response) => {
          setRowData([...rowData, { id: response.data.insertId, religion, ...images }]);
          resetForm();
        })
        .catch((error) => console.error("Error saving image:", error));
    }
  };

  const handleEdit = (data) => {
    setEditingRow(data);
    setReligion(data.religion);
    setImages({
      ldpi: data.ldpiUrl,
      mdpi: data.mdpiUrl,
      hdpi: data.hdpiUrl,
      xhdpi: data.xhdpiUrl,
      xxhdpi: data.xxhdpiUrl,
      xxxhdpi: data.xxxhdpiUrl,
    });
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this image?")) {
      axios
        .delete(`http://localhost:3001/images/${id}`)
        .then(() => setRowData(rowData.filter((row) => row.id !== id)))
        .catch((error) => console.error("Error deleting image:", error));
    }
  };

  const resetForm = () => {
    setEditingRow(null);
    setReligion("");
    setImages({
      ldpi: null,
      mdpi: null,
      hdpi: null,
      xhdpi: null,
      xxhdpi: null,
      xxxhdpi: null,
    });
    setErrors({});
  };

  return (
    <div className="p-6">
      {/* Image Upload Section */}
      <div className="bg-white shadow p-6 rounded mb-6">
        <h2 className="text-lg font-bold text-blue-600 mb-4">Image Upload</h2>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label>Religion *</label>
            <select
              value={religion}
              onChange={(e) => setReligion(e.target.value)}
              className="w-full p-2 border rounded mt-2"
            >
              <option value="">Select Religion</option>
              <option value="Hindu">Hindu</option>
              <option value="Christian">Christian</option>
              <option value="Muslim">Muslim</option>
            </select>
            {errors.religion && <p className="text-red-500 text-sm mt-1">{errors.religion}</p>}
          </div>
          {["ldpi", "mdpi", "hdpi", "xhdpi", "xxhdpi", "xxxhdpi"].map((res) => (
            <div key={res}>
              <label>{res.toUpperCase()} *</label>
              <input
                type="file"
                name={res}
                onChange={handleInputChange}
                className="w-full p-2 border rounded mt-2"
              />
              {errors[res] && <p className="text-red-500 text-sm mt-1">{errors[res]}</p>}
            </div>
          ))}
        </div>
        <button
          onClick={handleSave}
          className="bg-blue-500 text-white px-4 py-2 mt-4 rounded"
        >
          {editingRow ? "Update" : "Save"}
        </button>
      </div>

      {/* Edit Image Section */}
      <div className="bg-white shadow p-6 rounded">
        <h2 className="text-lg font-bold text-blue-600 mb-4">Edit Image</h2>
        <div className="ag-theme-alpine" style={{ height: 400, width: "100%" }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            pagination={true}
            paginationPageSize={5}
          />
        </div>
      </div>
    </div>
  );
};

export default Exit_image_upload;
